import { z } from "zod";
import { idSchema } from "./common.ts";

/**
 * Feature flags are defined here (code), their state lives in the database and is managed by
 * platform admins. A flag is on for an organization when it has an override saying so, otherwise
 * when the flag is on globally, otherwise when its default is on.
 */
export const FEATURE_FLAGS = {
  pos: { label: "POS", description: "Staff order entry for tables and the counter, voids, bills and closing checks.", default: false },
  table_management: { label: "Table management", description: "Floor-plan editor, the live floor, seating, moving and merging tables.", default: false },
} as const;
export type FeatureKey = keyof typeof FEATURE_FLAGS;
export const FEATURE_KEYS = Object.keys(FEATURE_FLAGS) as FeatureKey[];
export const featureKeySchema = z.enum(FEATURE_KEYS as [FeatureKey, ...FeatureKey[]]);
export type FeatureMap = Record<FeatureKey, boolean>;

export const setFeatureFlagSchema = z.object({ enabled: z.boolean() });
export const featureOverrideSchema = z.object({ organizationId: idSchema, enabled: z.boolean() });

export type AdminFeatureFlagDto = {
  key: FeatureKey;
  label: string;
  description: string;
  defaultEnabled: boolean;
  /** Global state (null: never changed, the default applies). */
  enabled: boolean;
  updatedAt: string | null;
  overrides: Array<{ organizationId: string; organizationName: string; enabled: boolean; createdAt: string }>;
};
